<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="12">
          <!--<h6>Simple Form</h6>-->
          <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>

          <b-form-group label="Satsangi Name" label-for="satsangiName">
            <b-form-input id="satsangiName" type="text" plaintext v-model.lazy.trim="form.satsangi_name" placeholder="Satsangi Name" autofocus />
          </b-form-group>

          <b-form-group label="Arrival Date" label-for="arrivalDate">
            <b-form-input id="arrivalDate" type="text" plaintext v-model.lazy="form.arrival_date" placeholder="Arrival Date" autofocus />
          </b-form-group>

          <b-form-group label="Departure Date" label-for="departureDate">
            <b-form-input id="departureDate" type="text" plaintext v-model.lazy="form.departure_date" placeholder="Departure Date" autofocus />
          </b-form-group>

          <b-form-group label="Building Name" label-for="buildingName">
              <v-select id="buildingName" :options="buildingList" v-model="form.building" @input="setSelected" :reduce="building => building.id" label="name" placeholder="Building Name"></v-select>
            </b-form-group>

            <b-form-group label="Room Number" label-for="roomNo">
              <v-select ref="roomNo" id="roomNo" :options="roomList"  aria-describedby="liveFeedbackRoomNo" v-model="form.room_no" :reduce="room => room.id" label="name" placeholder="Room Number"></v-select>
             <b-form-invalid-feedback id="liveFeedbackRoomNo">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>


            <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
              Submit
            </b-button>
            <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
          </b-form>
          <br />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</div>
</template>


<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import map from 'lodash/map'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required
} from "vuelidate/lib/validators"

const formShape = {
  satsangi_name: "",
  arrival_date: "",
  departure_date: "",
  building: "",
  reservation_id: "",
  room_no: "",
  assigned_room_id : ""
}


export default {
name: "ManualRoomAllocateEdit",
props: {
  booking: Object
},
data() {
  return {
    form: Object.assign({}, formShape),
    submitted: false,
    buildingChanged : 0
  }
},
validations: {
  form: {
    building: {
      required
      },
      room_no:{
        required
      }
  }
},
computed: {
isValid() {
  return !this.$v.form.$anyError
},
isDirty() {
  return this.$v.form.$anyDirty
},
buildingList() {
  return map(this.$store.state.buildings.simple, (building) => {
  return {
    name: building.name,
    id: building.id
  }

  })
},

roomList() {
  this.buildingChanged;
  return map(this.$store.state.rooms.buildingRooms, (room) => {
  return {
    name: room.room_number,
    id: room.room_id
  }

  })
}
},
methods: {

setSelected(value) {
    if(value.id){
        this.form.room_no = {};
        this.$store.dispatch('rooms/getBuildingRooms', {building_id: value.id});
        this.buildingChanged++;
    }
 },
onSubmit() {
  console.log(this.$v.form);
  if (this.validate()) {

    this.$nextTick(() => {
      this.submitted = true
      console.log(this.form.building);
      this.$store.dispatch('reservations/setManualRoom', {room_id:  this.form.room_no.id, reservation_id: this.form.reservation_id, assigned_room_id: this.form.assigned_room_id})
      .then(() => {
        this.$emit('success')
        this.showSuccessMsg()
      })
      .catch((error) => {
        if (error.response.status == 400) {
          this.showErrorMsg({
            message: error.response.data.message
          })
        } else {
          this.showErrorMsg()
        }
      })

    })
  }
},
chkState(val) {
  const field = this.$v.form[val]
  return field.$dirty ? !field.$invalid : null
},
findFirstError(component = this) {
  if (component.state === false) {
    if (component.$refs.input) {
      component.$refs.input.focus()
      return true
    }
    if (component.$refs.check) {
      component.$refs.check.focus()
      return true
    }
  }
  let focused = false
  component.$children.some((child) => {
    focused = this.findFirstError(child)
    return focused
  })

  return focused
},
validate() {
  this.$v.$touch()
  this.$nextTick(() => this.findFirstError())
  return this.isValid
},
  onCancel() {
    this.$emit('cancel')
  },
  onReset() {
    // Reset validation
    this.form = formShape
    this.submitted = false
    this.$nextTick(() => {
      this.$v.$reset()
    })
  },
},
beforeMount() {
  this.form.satsangi_name = this.booking.applicant_name
  this.form.arrival_date = this.booking.arrival_date
  this.form.departure_date = this.booking.departure_date
  this.form.building = this.booking.building
  this.form.assigned_room_id = this.booking.building.assigned_room_id
  this.form.reservation_id = this.booking.reservation_id
  this.form.room_no = {}


},
created() {
  if (this.$store.state.buildings.simple.length == 0) {
    this.$store.dispatch('buildings/getSimpleBuildings')
  }
  if (this.$store.state.rooms.buildingRooms.length == 0) {
    this.$store.dispatch('rooms/getBuildingRooms', {building_id: this.booking.building.id})

  }
  this.buildingChanged++;
}
}
</script>
